import { searchAction } from "../../store/actions/searchActions";
import Collapsible from "../layout/Collapsible";
import {
  toggleModalAction,
  addCollectionsAction,
  addVolumesAction,
  addAuthorsAction,
  addCollectionAction,
  addAuthorAction,
  addVolAction,
  removeAuthorAction,
  removeCollectionAction,
  removeCollectionsAction,
  removeAuthorsAction,
  removeVolAction,
} from "../../store/actions/filtersActions";
import MyCheckbox from "../layout/Checkbox";
import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchFilters } from "./FetchFilters";

class UrduFilters extends Component {
  constructor(props) {
    super(props);
    this.handleAuthorCheckbox = this.handleAuthorCheckbox.bind(this);
    this.handleCollectionCheckbox = this.handleCollectionCheckbox.bind(this);
    this.handleVolumeCheckbox = this.handleVolumeCheckbox.bind(this);
    this.showCollections = this.showCollections.bind(this);
    this.selectAllCollections = this.selectAllCollections.bind(this);
    this.selectAllAuthors = this.selectAllAuthors.bind(this);
    this.applyFilters = this.applyFilters.bind(this);
  }

  componentDidMount() {
    fetchFilters("new_urdu_books").then((res) => {
      const [authors, collsByAuthors, otherColls] = res;
      this.setState({ filtersResponse: { collsByAuthors, authors } });
    });
  }

  state = {
    selected: {
      authors: [],
      collections: [],
      vols: {},
    },
    filtersResponse: null,
  };

  handleAuthorCheckbox(e) {
    const aid = String(e.target.id);
    if (e.target.checked) {
      this.props.addAuthor(aid);
    } else {
      this.props.removeAuthor(aid);
    }
  }

  handleCollectionCheckbox(e) {
    const cid = String(e.target.id);
    if (e.target.checked) {
      this.props.addCollection(cid);
    } else {
      this.props.removeCollection(cid);
      // Clear volumes for this collection when deselected
      if (this.state.filtersResponse && this.state.filtersResponse.collsByAuthors) {
        // Find the collection in collsByAuthors to get numVolumes
        let numVolumes = null;
        for (const [author, collections] of Object.entries(this.state.filtersResponse.collsByAuthors)) {
          for (const [collKey, collData] of Object.entries(collections)) {
            if (String(collData["collID"]) === cid) {
              numVolumes = collData["numVolumes"];
              break;
            }
          }
          if (numVolumes !== null) break;
        }
        
        // If collection has volumes, remove them
        if (numVolumes && numVolumes > 1) {
          for (let vno = 1; vno <= numVolumes; vno++) {
            const volumeId = String(vno);
            if (this.props.filters.volumes.includes(volumeId)) {
              this.props.removeVolume(volumeId);
            }
          }
        }
      }
    }
  }

  handleVolumeCheckbox(e) {
    const volumeId = String(e.target.id.split('-')[2]);
    if (e.target.checked) {
      this.props.addVolume(volumeId);
    } else {
      this.props.removeVolume(volumeId);
    }
  }

  selectAllCollections(e) {
    let newSelected = [];
    const collDivs = e.target.parentNode.parentNode.nextSibling.firstChild.childNodes;
    collDivs.forEach((div) => {
      const checkboxID = div.firstChild.firstChild.id;
      const cid = String(checkboxID);
      newSelected = [...newSelected, cid];
    });

    e.target.checked
      ? this.props.addCollections(newSelected)
      : this.props.removeCollections();
  }

  selectAllAuthors(e) {
    let newSelected = [];
    const authDivs = e.target.parentNode.nextSibling.childNodes;

    authDivs.forEach((div) => {
      const aid = String(div.firstChild.firstChild.id);
      newSelected = [...newSelected, aid];
    });

    if (e.target.checked) {
      this.props.addAuthors(newSelected);
    } else {
      this.props.removeAuthors();
    }
  }

  showCollections(collsByAuthors) {
    return Object.entries(collsByAuthors).map((cbaEntry, index) => {
      const aname = cbaEntry[0];
      const collections = cbaEntry[1];
      return (
        <div key={index}>
          <Collapsible
            defaultExpanded={false}
            header={aname}
            preBody={
              <MyCheckbox label="Select all" onChange={this.selectAllCollections} />
            }
            body={
              <div className="filters-flex">
                {Object.entries(collections).map((collEntry, index) => {
                  const collName = collEntry[1]["collName"].replaceAll("_", " ");
                  const collID = String(collEntry[1]["collID"]);
                  const numVolumes = collEntry[1]["numVolumes"];
                  // Show volumes only if numVolumes is 2 or more (not 0, 1, "", null, or undefined)
                  const shouldShowVolumes = numVolumes && numVolumes > 1;
                  const isCollectionSelected = this.props.filters.collections.includes(collID);
                  
                  // Generate volume range if needed
                  const volumeRange = shouldShowVolumes 
                    ? Array.from({ length: numVolumes }, (v, k) => k + 1)
                    : [];

                  return (
                    <div key={index}>
                      <MyCheckbox
                        id={collID}
                        checked={isCollectionSelected}
                        label={collName}
                        onChange={this.handleCollectionCheckbox}
                      />
                      {shouldShowVolumes && isCollectionSelected && (
                        <div className="filters-flex volume-section" style={{ marginLeft: '20px', marginTop: '10px' }}>
                          {volumeRange.map((vno) => {
                            const volumeId = String(vno);
                            return (
                              <div key={`vol-${collID}-${vno}`}>
                                <MyCheckbox
                                  id={`vol-${collID}-${vno}`}
                                  label={`Volume ${vno}`}
                                  onChange={this.handleVolumeCheckbox}
                                  checked={this.props.filters.volumes.includes(volumeId)}
                                />
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            }
          />
        </div>
      );
    });
  }

  showAuthors(authors) {
    return (
      <div className="authors filters-flex">
        {authors.map((author, index) => {
          const { authorID, authorName } = author;
          return (
            <div key={index}>
              <MyCheckbox
                id={String(authorID)}
                onChange={this.handleAuthorCheckbox}
                checked={this.props.filters.authors.includes(String(authorID))}
                label={authorName}
              />
            </div>
          );
        })}
      </div>
    );
  }

  applyFilters() {
    this.props.perfromSearch(
      document.querySelector("#search_field").value,
      this.props.filters
    );
    this.props.toggleModal(false);
  }

  render() {
    return this.state.filtersResponse ? (
      <div>
        <legend>Authors</legend>
        <MyCheckbox label="Select all" onChange={this.selectAllAuthors} />
        {this.showAuthors(this.state.filtersResponse.authors)}
        <legend>Collections</legend>
        {this.showCollections(this.state.filtersResponse.collsByAuthors)}
        <div className="apply-filters-container">
          <button
            onClick={this.applyFilters}
            className="btn apply-filters-btn margin-auto display-block"
          >
            Apply and Search
          </button>
        </div>
      </div>
    ) : (
      <div>Loading...</div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    perfromSearch: (term, filters) => dispatch(searchAction(term, 0, filters)),
    addAuthors: (authors) => dispatch(addAuthorsAction(authors)),
    addCollections: (colls) => dispatch(addCollectionsAction(colls)),
    addVolumes: (vols) => dispatch(addVolumesAction(vols)),
    addCollection: (coll) => dispatch(addCollectionAction(coll)),
    addAuthor: (auth) => dispatch(addAuthorAction(auth)),
    addVolume: (vno) => dispatch(addVolAction(vno)),
    removeCollection: (coll) => dispatch(removeCollectionAction(coll)),
    removeCollections: () => dispatch(removeCollectionsAction()),
    removeAuthor: (auth) => dispatch(removeAuthorAction(auth)),
    removeAuthors: () => dispatch(removeAuthorsAction()),
    removeVolume: (vno) => dispatch(removeVolAction(vno)),
    toggleModal: (value) => dispatch(toggleModalAction(value)),
  };
};

const mapStateToProps = (state) => {
  return {
    filters: state.filters,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UrduFilters);